/** Raw `GhUserDto.status`/`UserStatus` wire value from the backend. */
export enum GhUserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

/** Derived from `GhUserDto.enabled` — whether the user's identity is provisioned at all. */
export enum IdentityStatus {
  Activated = 'Activated',
  Deactivated = 'Deactivated',
}

/** Derived from `GhUserStatus` — display value for the Medevac access toggle column. */
export enum UserAccessStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export interface UserRow {
  id: number;
  fullName: string;
  email: string;
  location: string;
  identityStatus: IdentityStatus;
  designation: string;
  status: UserAccessStatus;
  includeLocationIds: number[];
  excludeLocationIds: number[];
}

export interface RoleOption {
  label: string;
  value: string;
}

/** Splits a comma-separated designation value into individual, trimmed entries. */
export function splitDesignations(designation: string): string[] {
  return designation
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}
